/**
 * EmployeeAccountViewElement — blok „Konto pracownika" jako przenośny klocek
 * kreatora layoutu (konfigurowalne zakładki, kartoteka Pracownicy).
 *
 * Mirror `ContractorCompanyAccessViewElement` — element „widokowy" (panel akcji na
 * powiązanym koncie user'a, nie tabela → brak formatki kolumn). Na realnej stronie
 * dispatchowany przez `employeeContextRenderers['employee_account_view']`
 * (→ `EmployeeAccountTab`); w builderze stub z rejestru.
 * `allowedModules: ['employees']` — widoczny w palecie tylko dla Pracowników.
 */

import { KeyRound } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

export const EmployeeAccountViewElement: LayoutElementDefinition = {
  type: 'employee_account_view',
  category: 'tresc',
  isContainer: false,
  label: 'Konto pracownika',
  icon: 'key',
  allowedModules: ['employees'],
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="rounded-lg border border-dashed border-border-secondary bg-bg-secondary p-4 text-center"
      data-testid={`employee-account-view-element-${element.id}`}
      data-element-type="employee_account_view"
    >
      <KeyRound className="mx-auto h-5 w-5 text-text-muted" aria-hidden="true" />
      <p className="mt-1 text-xs font-medium text-text-secondary">
        {i18n.t('tenant.employees.accountBlock.paletteLabel', {
          defaultValue: 'Konto pracownika',
        })}
      </p>
    </div>
  ),
};
